<template>
  <sdf-alert-toast
    v-bind="$props"
    @sdfDismiss="$emit('sdf-dismiss', $event)"
    @sdfAfterClose="$emit('sdf-after-close', $event)"
    @sdfAfterOpen="$emit('sdf-after-open', $event)"
    @sdfAction="$emit('sdf-action', $event)"
  ></sdf-alert-toast>
</template>

<script setup lang="ts">
import type { JSX } from '@waypoint/web-components';

defineOptions({
  name: 'SdfAlertToast',
});

defineProps<Partial<JSX.SdfAlertToast>>();

defineEmits<{
  'sdf-dismiss': [event: CustomEvent];
  'sdf-after-close': [event: CustomEvent];
  'sdf-after-open': [event: CustomEvent];
  'sdf-action': [event: CustomEvent];
}>();
</script>
